<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import { bgColor } from '@/helpers/bgColor'

@Component({
    props: {
        schoolDataDisplayed: Object
    }
})

export default class SchoolAverages extends Vue {
    componentMeans = [
        'component1a_mean',
        'component1e_mean',
        'component2a_mean',
        'component2d_mean',
        'component3b_mean',
        'component3c_mean',
        'component3d_mean',
        'component4e_mean'
    ]

    bgColor(mean) {
        return bgColor(mean)
    }
}
</script>

<template>
    <table class="school-averages">
        <tbody>
            <tr>
                <slot></slot>
                <td v-for="(mean, index) in componentMeans" :key="index">
                    <span v-if="schoolDataDisplayed[mean]"
                        :style="{ backgroundColor: bgColor(schoolDataDisplayed[mean]) }">
                        {{ schoolDataDisplayed[mean].toFixed(2) }}
                    </span>
                    <span v-else>N/A</span>
                </td>
                <td class="transparent"></td>
            </tr>
        </tbody>
    </table>
</template>

<style lang="scss" scoped>

.school-averages {
    min-width: 1018px;
    margin: 15px auto;
    border-collapse: collapse;
    td, th {
        height: 64px;
        border: 1px solid #e5e3e6;
    }
    th {
        font-family: 'museo_slab';
        font-weight: normal;
        color: #4a4a4a;
        text-align: left;
        min-width: 100px;
        max-width: 100px;
        padding: 0 10px;
    }
    td {
        width: 95px;
        text-align: center;
        font-family: 'museo_sans';
        font-size: 18px;
        font-weight: normal;
        color: #4a4a4a;
        background: #f0f0f0;
        span {
            padding: 8px 19px;
        }
    }
    .transparent {
        background-color: transparent;
        border: none;
        width: 112px;
    }
}

</style>